export enum MessageSource {
  SMS = 'SMS',
  Facebook = 'Facebook',
  WebForm = 'Webform',
  Instagram = 'Instagram',
}
